import client from './client';

/**
 * 지면 상세보기 리스트
 */
export const openRtbMediaRtbDetail = (params) =>
  client.get(`/api/manage/openrtb/media_rtb/detail`, params);

/**
 * 지면 상세보기 리스트
 */
export const openRtbChildDetail = (params) =>
  client.get(`/api/manage/openrtb/child/detail`, { params: params });

/**
 * 지면 이력 확인
 */
export const openRtbStateLog = (params) =>
  client.get(`/api/manage/openrtb/state/log`, { params: params });

/**
 * 가중치 타게팅 리스트
 */
export const openRtbWeightGet = () =>
  client.get(`/api/manage/openrtb/weight/get`);

/**
 * 지면 상세보기 리스트
 */
export const openRtbsetOnOffMedia = (params) =>
  client.post(`/api/manage/openrtb/setOnOffMedia`, params);

/**
 * 지면 상세보기 가중치 수정
 */
export const openRtbSetting = (params) =>
  client.post(`/api/manage/openrtb/child/detail/set`, params);

/**
 * 오픈RTB 통계
 */
export const openrtbStatistics = (params) =>
  client.get(`/api/ch_report/openrtb/day`, params);

/**
 * 오픈RTB 통계 - 그래프
 */
export const openrtbGraph = (params) =>
  client.get(`/api/ch_report/openrtb/day/graph`, { params: params });

/**
 * 오픈RTB 상세 통계
 */
export const openrtbStatisticsDetail = (params) =>
  client.get(`/api/report/openrtb/day/sub`, params);

/**
 * 오픈RTB 지면별 통계
 */
export const openrtbMediaStatistics = (params) =>
  client.get(`/api/ch_report/openrtb/media`, params);

/**
 * 오픈RTB 지면별 시간대별 통계
 */
export const openrtbTimeStatistics = (params) =>
  client.get(`/api/ch_report/openrtb/time`, params);

/**
 * 오픈RTB 지면별 시간대별 통계 상세
 */
export const openrtbTimeStatisticsDetail = (params) =>
  client.get(`/api/ch_report/openrtb/time/sub`, params);

/**
 * 오픈RTB 광고주별통계
 */
export const openrtbAdverStatistics = (params) =>
  client.get(`/api/report/openrtb/adver`, params);

/**
 * 오픈RTB 타게팅별 통계
 */
export const openrtbTargetStatistics = (params) =>
  client.get(`/api/ch_report/openrtb/target`, params);

/**
 * 오픈RTB 타게팅통계 - 그래프
 */
export const openrtbTargetGraph = (params) =>
  client.get(`/api/ch_report/openrtb/target/graph`, { params: params });

/**
 * 오픈RTB RTB 관리
 */
export const openrtbMediaRtbStatistics = (params) =>
  client.get(`/api/manage/openrtb/media_rtb`, params);

/**
 * 오픈RTB 미승인 지면 통계
 */
export const openrtbUnappovedStatistics = (params) =>
  client.get(`/api/manage/openrtb/unapproved`, params);

/**
 * 오픈RTB 미승인 지면 삭제
 */
export const openrtbUnappovedDel = (params) =>
  client.delete(`/api/manage/openrtb/unapproved_del`, {
    data: { seq: params },
  });

/**
 * 오픈RTB Off 지면관리
 */
export const openrtbOfftatistics = (params) =>
  client.get(`/api/manage/openrtb/media_off`, params);

/**
 * 오픈RTB Off 상태 로그 리스트
 */
export const openrtbOffLogList = (params) =>
  client.get(`/api/manage/openrtb/off_list`, params);

/**
 * 오픈RTB Off 상태 팝업 지면 이력 확인
 */
export const openrtbMediaHistory = (params) =>
  client.get(`/api/manage/openrtb/state/log`, { params: params });
